function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 5.5,
  y: 10.5,
  width: 13,
  height: 10,
  rx: 3.5,
  stroke: "#D61F26"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 18C9 17.4696 9.31607 16.9609 9.87868 16.5858C10.4413 16.2107 11.2044 16 12 16",
  stroke: "#D61F26",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15 18C15 17.4696 14.6839 16.9609 14.1213 16.5858C13.5587 16.2107 12.7956 16 12 16",
  stroke: "#D61F26",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8 9C8 6.79086 9.79086 5 12 5C14.2091 5 16 6.79086 16 9V11H15V9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9V11H8V9Z",
  fill: "#D61F26"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5 14C13.5 14.8284 12.8284 15.5 12 15.5C11.1716 15.5 10.5 14.8284 10.5 14C10.5 13.1716 11.1716 12.5 12 12.5C12.8284 12.5 13.5 13.1716 13.5 14Z",
  stroke: "#D61F26"
});
const SvgBlockingForced = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBlockingForced, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/blockingForced.be7a96bc.svg";
export { ForwardRef as ReactComponent };